import { render, staticRenderFns } from "./MonitoringGeneral.vue?vue&type=template&id=a58640da&scoped=true"
import script from "./MonitoringGeneral.vue?vue&type=script&lang=js"
export * from "./MonitoringGeneral.vue?vue&type=script&lang=js"
import style0 from "./MonitoringGeneral.vue?vue&type=style&index=0&id=a58640da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58640da",
  null
  
)

export default component.exports